import React, { useContext, useEffect, useState } from 'react';
import { ParaCord } from './index';
import { Classes } from '@blueprintjs/core';
import * as d3 from 'd3';
import { WorkspaceContext } from '/views/workspace/workspaceContext';
import { WorkspaceActionCreator } from 'hooks/useWorkspaceState';
const stableDummyDispatch = () => {};
/**
 * ChartWrapper for the ParaCord widget.
 *
 * @param widgetConfiguration
 * @param dimensions
 * @param data
 * @param cardIndex
 * @param actions
 * @param loading
 * @returns {*}
 * @constructor
 */
export function ParaCordWrapper({ dimensions, data, cardIndex, actions, loading }) {
	// TODO: There's probably a less hacky way to get this component to work on the dashboard/savedViews pages
  	const { dispatch = stableDummyDispatch } = useContext(WorkspaceContext) ?? {};
	const [convertedData, setConvertedData] = useState(null);

	// TODO: Reimplement selection/filtering when strategy is determined.

	// send the
	// const onSelect = selected => {
	// 	dispatch(WorkspaceActionCreator.updateExplorerCardActions(cardIndex, { selected: selected }));
	// };

	useEffect(() => {
		// the data is null or in the wrong shape, so we exit
		if (!data || !(data?.properties && data?.links && data?.propertyOrder)) return;

		if (loading) return;

		const nodes = createNodes(data);
		// data only has less than two nodes, any result wouldn't make sense to the user
		if (Object.keys(nodes).length <= 1) return; 
		const links = createLinks(data, nodes);
		const propertyOrder = data.propertyOrder.map((p, i) => {
			return { label: p, index: i };
		});

		// new data need to clear the actions (if we are in the explorer)
		if (cardIndex) dispatch(WorkspaceActionCreator.updateExplorerCardActions(cardIndex, { selected: [] }));
		setConvertedData({ nodes, links, propertyOrder });
	}, [cardIndex, data, dispatch, loading]);

	return !!convertedData ? (
		<ParaCord
			data={convertedData}
			columns={{}}
			dimensions={dimensions}
			//onSelect={onSelect}
			//selected={actions?.selected}
		/>
	) : (
		<div className={Classes.SKELETON} style={{ width: dimensions.width, height: dimensions.height }} />
	);
}

// Process the rawData into objects that will be the nodes
const createNodes = rawData => {
	// Create a node for each property value
	let nodes = {};
	rawData.propertyOrder.forEach((property, i) => {
		nodes[property] = {};
		Object.entries(rawData.properties[property]).forEach((value, j) => {
			// node is [label, count]
			nodes[property][value[0].toLowerCase()] = {
				key: value[0].toLowerCase(),
				count: value[1],
				label: value[0],
				propertyIndex: i,
				propertyKey: rawData.propertyOrder[i],
				valueIndex: j,
			};
		});
	});

	return nodes;
};

// Create the links, can be filtered and links in the visualization.
const createLinks = rawData => {
	// Create a renderable link for each ordered pair of values in each link
	let links = {};
	rawData.links.forEach(link => {
		for (let i = 0; i < rawData.propertyOrder.length - 1; i++) {
			// get the pairs of values
			const srcValue = link.link[i].toLowerCase();
			const tgtValue = link.link[i + 1].toLowerCase();

			// create a unique reproducible key
			const key = `${i}*${srcValue}^${i + 1}*${tgtValue}`;

			if (links[key]) {
				links[key].count += link.count;
				links[key].full = links[key].full.concat(link.link.map(l => l.toLowerCase()));
			} else {
				// store the renderable link
				links[key] = {
					source: { propertyIndex: i, propertyKey: rawData.propertyOrder[i], value: srcValue },
					target: { propertyIndex: i + 1, propertyKey: rawData.propertyOrder[i + 1], value: tgtValue },
					count: link.count,
					key: key,
					full: link.link.map(l => l.toLowerCase()),
				};
			}
		}
	});

	// we don't need the map any longer
	links = Object.values(links);
	links = links.map(link => {
		link.full = Array.from(new Set(link.full));
		return link;
	});

	return {
		links: links,
		maxLinkCount: d3.max(links, l => l.count),
	};
};
